import { ItemKind } from '../../../constants/ItemKind';
const EXTERNAL_SOURCES = ['shutterStock', 'unsplash'];
function getItemMediaType(item) {
  if (item.kind === ItemKind.Folder) {
    return 'folder';
  }
  if (item.kind === ItemKind.File) {
    return item.mediaType;
  }
  throw new Error("Unsupported item kind " + item.kind);
}
export function toBackendItem(item) {
  if (EXTERNAL_SOURCES.indexOf(item.source) !== -1) {
    return {
      src_id: item.id,
      src_type: 'external',
      media_type: getItemMediaType(item),
      src_info: item,
      title: item.name
    };
  }
  if (item.source === 'public' || item.source === 'custom') {
    return {
      src_id: item.id,
      src_type: 'public',
      media_type: getItemMediaType(item),
      src_info: item,
      title: item.name
    };
  }
  return {
    src_id: item.id,
    src_token: item.siteMediaToken,
    src_type: item.kind,
    media_type: getItemMediaType(item)
  };
}